"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _Media = _interopRequireDefault(require("./Media"));

var _Panels = _interopRequireDefault(require("./Panels"));

var _Meta = _interopRequireDefault(require("../common/Meta"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint react/forbid-prop-types:0 */
function convertExternalHits(externalHits) {
  try {
    var result = [];
    var hitObject = typeof externalHits === "string" && (externalHits === null || externalHits === void 0 ? void 0 : externalHits.length) ? JSON.parse(externalHits.replace(/&quot;/g, '"')) : externalHits; // let startList = hitObject.hits.reduce((total,hit) => {total.push(hit.s); return total}, []);

    if (hitObject && (0, _lodash.isArray)(hitObject.hits) && hitObject.hits.length > 0) {
      var keywords = hitObject.hits.reduce(function (total, hit, index) {
        if (!(0, _lodash.isEmpty)(hit.s)) {
          total.push({
            internalName: [],
            name: hit.label || "Hit " + index,
            score: 1,
            t: {
              speaker: hit.s
            }
          });
        }

        return total;
      }, []);
      hitObject.keywords = keywords;
      hitObject.type = "category";
      result.push(hitObject);
    }

    return result;
  } catch (error) {
    console.warn("#### External Hits: Invalid JSON: ", error);
    return [];
  }
}

var Index = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Index, _React$Component);

  function Index() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      marks: []
    });

    return _this;
  }

  var _proto = Index.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        parsedFromAnalytics = _this$props.parsedFromAnalytics,
        player = _this$props.player,
        externalHits = _this$props.externalHits,
        startTime = _this$props.startTime,
        advanceToFirstHit = _this$props.advanceToFirstHit,
        isPCIFlagEnabled = _this$props.isPCIFlagEnabled,
        showPCIFlag = _this$props.showPCIFlag,
        handlePCIFlagClick = _this$props.handlePCIFlagClick,
        flagAction = _this$props.flagAction,
        handleMinimizePlayer = _this$props.handleMinimizePlayer,
        hidePlayer = _this$props.hidePlayer,
        transcriptLength = _this$props.transcriptLength;
    var mediaId = parsedFromAnalytics.mediaId;
    var convertedExternalHits = convertExternalHits(externalHits);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "player-container"
    }, /*#__PURE__*/_react["default"].createElement(_Meta["default"], null), /*#__PURE__*/_react["default"].createElement(_Media["default"], {
      mediaUrl: player.mediaUrl,
      analytics: parsedFromAnalytics,
      startTime: startTime,
      externalHits: convertedExternalHits,
      advanceToFirstHit: advanceToFirstHit
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Panels["default"], {
      transcriptLength: transcriptLength,
      parsedFromAnalytics: parsedFromAnalytics,
      player: player,
      externalHits: convertedExternalHits,
      isPCIFlagEnabled: isPCIFlagEnabled,
      showPCIFlag: showPCIFlag,
      handlePCIFlagClick: handlePCIFlagClick,
      flagAction: flagAction,
      handleMinimizePlayer: handleMinimizePlayer,
      hidePlayer: hidePlayer
    }))));
  };

  return Index;
}(_react["default"].Component);

var _default = Index;
exports["default"] = _default;